import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled(Box)`
  display: flex;
  width: 100%;
`;
